import React, { ReactNode, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import { cn } from '@/helper/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string | ReactNode;
  error?: string;
  required?: boolean;
  labelColor?: string;
  containerClassNames?: string;
  inputClassNames?: string;
  leading?: ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type = 'text',
      required = false,
      label,
      className,
      error,
      id,
      labelColor,
      containerClassNames,
      inputClassNames,
      leading,
      ...rest
    },
    ref
  ) => {
    const [internalType, setInternalType] = useState(type);

    function toggleInternalType() {
      if (internalType === 'password') setInternalType('text');
      else setInternalType('password');
    }

    return (
      <div className={cn('mb-4', containerClassNames)}>
        {label && (
          <label htmlFor={id} className={cn('mb-1 block', labelColor)}>
            {label}
            {required && <span className="text-buttonOrange">*</span>}
          </label>
        )}

        <div
          className={cn(
            'group focus-within:shadow-md flex items-center gap-1 justify-between bg-inherit h-[54px] border border-[#CBD5E1] w-full rounded-lg bg-white px-2',
            inputClassNames
          )}
        >
          {leading && leading}
          <input
            ref={ref}
            id={id}
            type={internalType}
            className={cn(
              'h-full px-3 py-2 placeholder-[#CBD5E1] w-full border-0 outline-none focus:ring-0 bg-transparent disabled:cursor-not-allowed rounded-lg',
              className
            )}
            {...rest}
          />
          {type === 'password' && (
            <span className="flex items-center pr-3 cursor-pointer h-[54px]" onClick={toggleInternalType}>
              {internalType === 'password' ? (
                <FaEye className="text-[#CBD5E1]" />
              ) : (
                <FaEyeSlash className="text-[#CBD5E1]" />
              )}
            </span>
          )}
        </div>

        {error && <span className="text-sm text-buttonOrange">{error}</span>}
      </div>
    );
  }
);

Input.displayName = 'Input';
